import {
  conceptInstanceInterface,
  drugConceptsList,
  moleculeAndConceptDetailsByGfcResponseInterface,
  moleculeConceptRequestBodyPaylod,
  NDCEditFormDropDownResponseInterface,
  NDCInformationInterface,
  ppsDataInterface,
  ppsscDataInterface,
  segmentationDataInterface,
  targetMarketShareHistoryResponseInterface,
  targetMarketShareInstanceInterface,
  targetMarketShareUpdateInterface,
  targetMarketShareUpdateResponseInterface,
  targetMarketStrategyCode,
  tmsDataInterface,
  tmsHistoricalValueRequestPayloadInterface,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import {
  futureNdcDeactivatationRequestPayload,
  ndcHistoryDataInterface,
  ndcHistoryRequestPayloadInterface,
  ndcUpdateInterface,
  ndcUpdateRequestPayloadInterface,
} from 'Interfaces/FactsInterfaces/ndcInterfaces';
import { getRequest, postRequest, formDataPostRequest } from 'config/Axios/baseConfig';
import {
  bulkUploadDataValidationInterface,
  bulkUploadDataValidationInterfaceInstance,
  bulkUploadTmsResponseInterface,
  futureTmsDeactivatationRequestPayload,
  totalTmsResponseInterface,
} from 'Interfaces/FactsInterfaces/tmsInterfaces';

export const factScreenServices = {
  /**
   * @returns details of all the concepts
   */
  getAllMoleculeDetails: (): Promise<conceptInstanceInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<conceptInstanceInterface[]>(`facts/gsms-concepts`);
        resolve(data);
      } catch (error) {
        console.log('in services > getConceptDetails, Err===', error);
        reject(error);
      }
    });
  },

  getParticularMoleculeDetails: (
    payload: moleculeConceptRequestBodyPaylod
  ): Promise<drugConceptsList> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<drugConceptsList>(`facts/concepts`, payload);
        resolve(data);
      } catch (error) {
        console.log('in services > getParticularMoleculeDetails, Err===', error);
        reject(error);
      }
    });
  },

  getConceptsAndMoleculeNamebyGfc: (
    GFC: string
  ): Promise<moleculeAndConceptDetailsByGfcResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<moleculeAndConceptDetailsByGfcResponseInterface>(
          `facts/concepts-by-gfc/${GFC}`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getConceptAndMoleculeNamebyGfc, Err===', error);
        reject(error);
      }
    });
  },

  getTargetMarketShareByGFC: (
    GFC: string,
    signal: AbortController['signal'] | null = null
  ): Promise<targetMarketShareInstanceInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<targetMarketShareInstanceInterface[]>(
            `facts/get-target-market-share/${GFC}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<targetMarketShareInstanceInterface[]>(
            `facts/get-target-market-share/${GFC}`
          );
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getTargetMarketShareByGFC, Err===', error);
        reject(error);
      }
    });
  },

  getTargetMarketStrategyCodes: (): Promise<targetMarketStrategyCode[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<targetMarketStrategyCode[]>(
          `facts/target-market-strategy-codes`
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getTargetMarketShareByGFC, Err===', error);
        reject(error);
      }
    });
  },

  getNdcInformationByGFC: (
    GFC: string,
    signal: AbortController['signal'] | null = null
  ): Promise<NDCInformationInterface[]> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<NDCInformationInterface[]>(
            `facts/get-ndc-info/${GFC}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<NDCInformationInterface[]>(`facts/get-ndc-info/${GFC}`);
          resolve(data);
        }
      } catch (error) {
        console.log('in services > getNdcInformationByGFC, Err===', error);
        reject(error);
      }
    });
  },

  getMarketShareHistoryValues: (
    payload: tmsHistoricalValueRequestPayloadInterface
  ): Promise<targetMarketShareHistoryResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<targetMarketShareHistoryResponseInterface>(
          `facts/target-market-history`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getMarketShareHistoryValues, Err===', error);
        reject(error);
      }
    });
  },

  getNdcEditFormFields: (): Promise<NDCEditFormDropDownResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } =
          await getRequest<NDCEditFormDropDownResponseInterface>(`facts/ndc-fields-values`);
        resolve(data);
      } catch (error) {
        console.log('in services > getNdcEditFormFields, Err===', error);
        reject(error);
      }
    });
  },

  addTMSStrategy: (tmsStrategydata: tmsDataInterface): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `facts/add-new-tms-strategy`,
          tmsStrategydata
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  addNewPPS: (ppsData: ppsDataInterface): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(`facts/add-new-PPS`, ppsData);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  addNewPPSSC: (ppsscData: ppsscDataInterface): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(`facts/add-new-PPS-Reason`, ppsscData);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  getNdcHistory: (payload: ndcHistoryRequestPayloadInterface): Promise<ndcHistoryDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ndcHistoryDataInterface>(
          `facts/get-hist-ndc-info`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getNdcHistory, Err===', error);
        reject(error);
      }
    });
  },
  addNewSegmentation: (segmentationData: segmentationDataInterface): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `facts/add-new-Segmentation`,
          segmentationData
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  },

  extendMarketShareEndDate: (
    payload: targetMarketShareUpdateInterface
  ): Promise<targetMarketShareUpdateResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<targetMarketShareUpdateResponseInterface>(
          `facts/extend-tms`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > extendMarketShareEndDate, Err===', error);
        reject(error);
      }
    });
  },

  updateMarketShareData: (
    payload: targetMarketShareUpdateInterface
  ): Promise<targetMarketShareUpdateResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<targetMarketShareUpdateResponseInterface>(
          `facts/update-tms`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > updateMarketShareData, Err===', error);
        reject(error);
      }
    });
  },

  updateNdcPpsPpscInfo: (
    payload: ndcUpdateRequestPayloadInterface
  ): Promise<ndcUpdateInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ndcUpdateInterface>(
          `facts/update-and-create-pricing-component-and-reporting-segment`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > updateNdcPpsPpscInfo, Err===', error);
        reject(error);
      }
    });
  },

  extendNdcStrategies: (payload: ndcUpdateRequestPayloadInterface): Promise<ndcUpdateInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<ndcUpdateInterface>(
          `facts/extend-ndc-strategies`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > extendNdcStrategies, Err===', error);
        reject(error);
      }
    });
  },
  // getNdcHistory: (): Promise<NDCEditFormDropDownResponseInterface> => {
  //     return new Promise(async (resolve, reject) => {
  //         try {
  //             const { data } = await getRequest<NDCEditFormDropDownResponseInterface>(
  //                 `facts/ndc-fields-values`
  //             );
  //             resolve(data);
  //         } catch (error) {
  //             console.log("in services > getNdcEditFormFields, Err===", error);
  //             reject(error);
  //         }
  //     });
  // },

  deactivateFutureTms: (
    payload: futureTmsDeactivatationRequestPayload
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `facts/deactivate-future-tms`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > deactivateFutureTms, Err ===', error);
        reject(error);
      }
    });
  },

  deactivateFutureNdc: (
    payload: futureNdcDeactivatationRequestPayload
  ): Promise<{ data: string }> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<{ data: string }>(
          `facts/deactivate-future-ndc`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > deactivateFutureNdc, Err ===', error);
        reject(error);
      }
    });
  },

  getTotalTmsCalculationForDirectIndirectandOverall: (
    gfc: string,
    signal: AbortController['signal'] | null = null
  ): Promise<totalTmsResponseInterface> => {
    return new Promise(async (resolve, _reject) => {
      try {
        if (signal) {
          const { data } = await getRequest<totalTmsResponseInterface>(
            `facts/average-tms/${gfc}`,
            undefined,
            { signal }
          );
          resolve(data);
        } else {
          const { data } = await getRequest<totalTmsResponseInterface>(`facts/average-tms/${gfc}`);
          resolve(data);
        }
      } catch (error) {
        console.log(
          'in services > getTotalTmsCalculationForDirectIndirectandOverall, Err===',
          error
        );
      }
    });
  },
  getTmsBulkUpdatePreviewData: (formData: FormData): Promise<bulkUploadDataValidationInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await formDataPostRequest<bulkUploadDataValidationInterface>(
          `facts/bulk-update-data-preview`,
          formData
        );
        resolve(data);
      } catch (error) {
        console.log('in services > getTmsBulkUpdatePreviewData, Err ===', error);
        reject(error);
      }
    });
  },

  bulkUpdateTms: (
    payload: bulkUploadDataValidationInterfaceInstance[]
  ): Promise<bulkUploadTmsResponseInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<bulkUploadTmsResponseInterface>(
          `facts/tms-bulk-update`,
          payload
        );
        resolve(data);
      } catch (error) {
        console.log('in services > bulkUpdateTmsEndpoint, Err ===', error);
        reject(error);
      }
    });
  },
};

// getTargetMarketShareByGFC: (
//   GFC: string,
//   signal: AbortController["signal"] | null = null
// ): Promise<targetMarketShareInstanceInterface[]> => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       if (signal) {
//         const { data } = await getRequest<
//           targetMarketShareInstanceInterface[]
//         >(`facts/get-target-market-share/${GFC}`, undefined, { signal });
//         resolve(data);
//       } else {
//         const { data } = await getRequest<
//           targetMarketShareInstanceInterface[]
//         >(`facts/get-target-market-share/${GFC}`);
//         resolve(data);
//       }
//     } catch (error) {
//       console.log("in services > getTargetMarketShareByGFC, Err===", error);
//       reject(error);
//     }
//   });
// },
